import React from 'react';
import PropTypes from 'prop-types';

import 'material-design-icons-iconfont/dist/material-design-icons.css';

/**
 * MaterialIcon renders a material.io icon (https://material.io/icons/)
 *
 * @param {string} icon the name of the icon, exactly matching an icon documented at https://material.io/icons/
 * @param {string} className optional CSS classes to add to the material icon
 * @returns {node} material icon
 */
const MaterialIcon = ({icon, className = '', ...rest}) =>
  <i className={"material-icons " + className} {...rest} data-role="materialIcon">
    {icon}
  </i>;

MaterialIcon.propTypes = {
  className: PropTypes.string,
  icon: PropTypes.string.isRequired
};

export default MaterialIcon;
